import { venus } from '@solarApi';
import { establishments } from '@solarApiResources';

// eslint-disable-next-line import/prefer-default-export
export const fetchAssociatedEstablishments = async () => {
  const { data } = await venus.request({
    url: establishments.list.url,
    method: establishments.list.method,
  });

  return data.map((d) => ({
    id: d.id,
    ...d.data,
  }));
};
